import { PortalUserInfo } from 'src/app/front-user/common-features/registration/portal-user.model';
import { AgentInfo } from '../../services/e-booking/shared/models/agent.model';
import { SupplierDTO } from 'src/app/shared/models/e-tender.model';

export class AdminUser{
    UserName: string;
    Id: string;
    Title: string;
    Email:string; 
}
export class User {
    UserName: string;
    UserId: string;
    FullName: string;
    Password: string;
    ConfrimPassword: string;
    RegisterTypeId : number;
    IsAdmin: boolean=false;
    role : Role;
    PortalUser: PortalUserInfo = new PortalUserInfo();
    Agent: AgentInfo = new AgentInfo();
    recaptcha :string;
    Email:string; 
    Name:string; 
    Phone:string;
    CompanyName:string;
    Phone1:string; 
    Address:string; 
    Organization :string;
    Fax:string;
    CountryId :number;
    Mobile:string;
    Supplier: SupplierDTO = new SupplierDTO();
    RequestId:string;
};

export enum Role {
    user = 'User',
    admin = 'Admin'
}